import { bitcashRoom } from 'app-view/hooks/use-realtime'
import { CoinGeckoPrices } from 'app-engine/types'

export const useRealTimeCoinPrices = () => {
  const _coinPrices = bitcashRoom.useColyseusState((state) => state.coinPrices)
  const coinPrices = _coinPrices ? (_coinPrices.toJSON() as CoinGeckoPrices) : {}
  return coinPrices
}
